// Single typed API client instance.
//
// VITE_API_URL is read once at module load. `getAuthToken` is resolved fresh
// on each request, so a login mutation that updates the auth store is picked
// up by subsequent calls without re-creating the client.

import { createClient } from "@incorposano/api-client";

import { useAuth } from "@/stores/auth";

// Empty string = same-origin requests (Vite proxy forwards /api/* to the
// backend in dev; in prod the reverse proxy does the same job).
const baseUrl = import.meta.env.VITE_API_URL ?? "";

export const api = createClient({
  baseUrl,
  getAuthToken: () => useAuth.getState().token,
});
